import { Injectable, inject } from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {Location} from '@angular/common';

@Injectable({
    providedIn: 'root'
})
export class NavigationService {
    private router = inject(Router);
    private location = inject(Location);

    private initialized = false;
    private history: string[] = [];

    initialize() {
        if(!this.initialized) {
            this.initialized = true;
            this.router.events.subscribe(event => {
                // check if url is same as last in history, skip if duplicate
                if (event instanceof NavigationEnd && event.urlAfterRedirects !== this.history[this.history.length - 1]) {
                    this.history.push(event.urlAfterRedirects);
                }
            });
        }
    }

    back(): void {
        if (this.isIframe() && this.history.length == 1) {
            // Normally targetOrigin should never be * but the message here is not secret so its not important
            window.parent.postMessage('back', '*');
        }
        this.history.length > 0 ? this.location.back() : this.router.navigate(['']);
    }

    private isIframe() {
        return window !== window.parent
    }
}
